import AccountSectionsList from './AccountSectionsList';

export default AccountSectionsList;
